import { Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { ArrowCircleLeft, ArrowCircleRight, PhotoCameraFront } from '@mui/icons-material'
import person from '../../../Assets/Imgs/person.png'

const style = {
    typographyStyle: {
        fontWeight: 700,
        fontSize: '13px',
        textAlign: 'center',
        height: '18px'
    },
    imgStyle: {
        height: '71px',
        width: '69px',
        borderRadius: '5px'
    }
}

const CardDestaque = ({ acesso, openVideoFunction, idCentral }) => {
    const { id, data, funcao, nome, descAcesso, evento, img_perfil, ids_camera_gravacao, sentido } = acesso

    const isMorador = ['MORADOR', 'Proprietário(a)', 'Família', 'Responsável', 'Filho(a)', 'Esposa(o)', 'Sindico (AppOne)', 'Proprietario (AppOne)'].includes(funcao)
    const color = evento == 'OANG' ? '#FF0000' : isMorador ? '#0FBB00' : '#FB9B0C'

    const imgPerfil = `${window.location.origin.replace(':3003', '')}/wsOnePortaria/web/images/${img_perfil}?${new Date().getTime()}`
    const imgTag = `${window.location.origin.replace(':3003', '')}/wsOnePortaria/web/images/${idCentral}/f${acesso.cd_acesso}.jpg?${new Date().getTime()}`

    const img = img_perfil ? imgPerfil : imgTag

    const id_camera = (ids_camera_gravacao) ? ids_camera_gravacao.split(',')[0] : ''

    return (
        <Grid
            container
            sx={{
                border: `3px solid ${color}`,
                borderRadius: '5px',
                height: '81px',
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignContent: 'center',
                padding: '1px',
                backgroundColor: '#A8A4AB'
            }}
            gap={1}
        >
            <Grid
                item
                container
                sx={{
                    width: '150px',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'start',
                    alignContent: 'center',
                    flexDirection: 'row',
                    padding: 0,
                    margin: 0
                }}
                gap={1}
            >
                <img key={`${nome}-img`} style={style.imgStyle} src={img} onError={(e) => {
                    e.target.onerror = (e) => {
                        console.log(e.target.src)
                        e.target.onerror = null
                        e.target.src = person
                    }
                    e.target.src = imgTag
                }} />
                <PhotoCameraFront
                    sx={{ color: (id_camera ? 'black' : 'gray'), cursor: (id_camera ? 'pointer' : ''), ...style.imgStyle }}
                    onClick={() => id_camera ? openVideoFunction(id, id_camera) : null}
                />
            </Grid>
            <Grid item container style={{
                display: 'flex',
                justifyContent: 'center',
                alignContent: 'center',
                flexDirection: 'column',
                height: '100%',
                width: 'calc(100% - 160px)',
                flexWrap: 'noWrap'
            }}>
                <Typography sx={style.typographyStyle} >{data}</Typography>
                <Typography sx={{ ...style.typographyStyle, backgroundColor: '#D9D9D9' }} >{isMorador ? 'Usuário' : 'Visitante'}</Typography>
                <Typography sx={style.typographyStyle} >{nome}</Typography>
                <Typography sx={{ ...style.typographyStyle, backgroundColor: '#D9D9D9', display: 'flex', justifyContent: 'center', gap: 1 }} >
                    {descAcesso}{sentido && <span style={{ display: 'flex', justifyContent: 'center' }}>
                        {sentido == 'E' ? <ArrowCircleRight sx={{ fontSize: '17px', color: '#027502' }} /> : <ArrowCircleLeft sx={{ fontSize: '17px', color: '#c70505' }} />}
                    </span>
                    }
                </Typography>
            </Grid>
        </Grid>
    )
}

export default CardDestaque
